import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFigmaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	role: "img",
	viewBox: "0 0 38 57",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Figma" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1abcfe",
			d: "M19 28.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0acf83",
			d: "M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff7262",
			d: "M19 0v19h9.5a9.5 9.5 0 1 0 0-19H19z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f24e1e",
			d: "M0 9.5A9.5 9.5 0 0 0 9.5 19H19V0H9.5A9.5 9.5 0 0 0 0 9.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a259ff",
			d: "M0 28.5A9.5 9.5 0 0 0 9.5 38H19V19H9.5A9.5 9.5 0 0 0 0 28.5z"
		})
	]
});
export default SvgFigmaIcon;
